import React, { PropTypes } from 'react';
import ModalDialog from 'common/components/modal/modal_dialog';
import VoteRevision from 'focus_groups/containers/vote_revision';
import VoteBar from 'focus_groups/containers/vote_bar';

const VotingModal = ({ isVoting, toggle }) => (
  <ModalDialog
    dialogClasses="focus-group-voting-modal"
    contentClasses="wide"
    modalOpen={isVoting}
    closeAction={toggle}
    showClose={true}
    modalHeader="Rate this Entry"
  >
    <VoteRevision />
    <VoteBar />
  </ModalDialog>
);

VotingModal.propTypes = {
  isVoting: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
};

export default VotingModal;



// WEBPACK FOOTER //
// ./focus_groups/components/voting_modal.jsx